import { render } from "./bussiness-settings.vue?vue&type=template&id=26917e59"
import script from "./bussiness-settings.vue?vue&type=script&lang=js"
export * from "./bussiness-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__